import React, { FC } from 'react';
import { DefaultSpaceIcon } from 'components/icons/reserved';
import type { IconProps } from 'components/icons/createIcon';

interface SpaceIconProps extends IconProps {
  name: string | undefined;
}

export const SpaceIcon: FC<SpaceIconProps> = ({ name, ...props }) => {
  return <DefaultSpaceIcon {...props} />;
};

export default SpaceIcon;
